<template>
    <section class="investment-solutions-section background-is-light py-md-5 px-0 pl-md-2">
        <h2 class="heading-5 sr-only"><slot name="hl-invest-investsectiontitle"></slot></h2>
        <scroll-carousel :scrollHeight="3000" contentComponent="investment-solutions-carousel" :culture-code="cultureCode">
        </scroll-carousel>
    </section>
</template>

<script>
    import HButton from '../components/HButton.vue';
    import BorderedImage from '../components/BorderedImage.vue'
    import ScrollCarousel from "../components/ScrollCarousel.vue";
    import InvestmentSolutionsCarousel from "../systems/InvestmentSolutionsCarousel.vue";
    import Vue from "vue";

    Vue.component("investment-solutions-carousel", InvestmentSolutionsCarousel);
    export default {
        components: {
            HButton,
            BorderedImage,
            ScrollCarousel,
            InvestmentSolutionsCarousel
        },
        props: {
            cultureCode: {
                type: String,
                default: "en-US"
            }
        }
    }
</script>

<style lang="scss">
    .investment-solutions-section {
        background-color: $white;

        .scroll-carousel-locked-content {

            @include respond-above(md) {
                padding-top: 90px;
                padding-bottom: 45px;
            }
        }
    }
</style>
